<header *ngIf="DialogData">
    <h1 mat-dialog-title>{{Headline$ | async}}</h1>
    <span class="spacer"></span>
    <button mat-icon-button (click)="closeDialog()"  matTooltip="Schließen">
        <fa-icon icon="times" size="2x"></fa-icon>
    </button>
</header>
<mat-horizontal-stepper [class.stepper-disabled]="!CommissionId " linear #Stepper [class.mat-dialog-content]="!!DialogData">
    <ng-container *ngIf="Steps$ | async as steps">
        <mat-step *ngFor="let step of steps; let i = index">
            <ng-template matStepLabel>{{ step.name }}</ng-template>
            <app-detail-list-template *ngIf="step.data" [Inline]="true" [Data]="step.data | async" [Editing]="true"> </app-detail-list-template>
            <ng-container [ngTemplateOutlet]="step.customTemplate"></ng-container>
        </mat-step>
    </ng-container>
    <ng-template matStepperIcon="edit">
        <fa-icon icon="pencil-alt"></fa-icon>
    </ng-template>
    <ng-template matStepperIcon="done">
        <fa-icon icon="check"></fa-icon>
    </ng-template>
    <ng-template matStepperIcon="error">
        <fa-icon icon="exclamation-triangle"></fa-icon>
    </ng-template>
</mat-horizontal-stepper>
<div class="buttons" [class.mat-dialog-actions]="!!DialogData" *ngIf="Steps$ | async as Steps">
    <a *ngIf="DialogData && Steps && Stepper.selectedIndex === Steps.length - 1"
       app-button
       [Disabled]="Steps[Stepper.selectedIndex].controlsInvalid() || !(isCommissionTypeValid$ | async) || (ls.IsLoading$ | async)"
       matTooltip="Auftrag speichern & anzeigen"
       (click)=" NextAndDetailsClick(Steps);"
       Color="green"

    >
        Speichern & Details
    </a>
    <button *ngIf="Steps"
        app-button
        [Disabled]="Steps[Stepper.selectedIndex].controlsInvalid() || !(isCommissionTypeValid$ | async) || (ls.IsLoading$ | async)"
        (click)=" NextClick(Steps);"
        [Color]="(Stepper.selectedIndex === Steps.length - 1 || (this.kaplParentIdSet$ | async)) ? 'green' : undefined"
    >
        {{ (Stepper.selectedIndex === Steps.length - 1 || (this.kaplParentIdSet$ | async) ) ? 'Speichern' : (IsNewCommission && Stepper.selectedIndex === 0 ? 'Speichern und Weiter' : 'Weiter') }}
    </button>
    <button *ngIf="Steps && (this.kaplParentIdSet$ | async)"
            app-button
            [Disabled]="Steps[Stepper.selectedIndex].controlsInvalid() || !(isCommissionTypeValid$ | async) || (ls.IsLoading$ | async)"
            (click)="openNewCommissionWizard(); NextClick(Steps);"
            [Color]="'green'"
    >
        {{   'Speichern & weitere ' + (this.cls.getMultiple$('Commission') | async)+ ' anlegen'  }}
    </button>
    <button *ngIf="Stepper.selectedIndex" style="margin-right: auto;" app-button Inverted (click)="Stepper.previous()">
        Zurück
    </button>
    <button *ngIf="DialogData && Stepper.selectedIndex === 0" style="margin-right: auto;" app-button Inverted (click)="closeDialog()" Color="cancel">
        Abbrechen
    </button>
</div>
<ng-template #selectTeamTemplate>
    <div class="ressourceTemplate" *ngIf="CommissionId$ | async as commissionId">
        <app-select-user-commission-dialog #selectUserCommissionDialogComponent [PreventDialog]="true" [ComponentData]="{commissionId}"></app-select-user-commission-dialog>
        <button class="ressourceSaveButton" app-button (click)="selectUserCommissionDialogComponent.Submit()" [IsLoading]="selectUserCommissionDialogComponent.LS.IsLoading$ | async" Color="green">Speichern</button>
    </div>
</ng-template>

<ng-template #resourceTemplate>
    <div class="ressourceTemplate">
        <app-select-resource #selectResourceComponent [ComponentData]="{CommissionId: CommissionId}"></app-select-resource>
        <button class="ressourceSaveButton" app-button (click)="selectResourceComponent.Save()">Ressourcen zuweisen</button>
    </div>
</ng-template>

<ng-template #capacityTemplate>
    <div class="capacityTemplate">
        <div class="headline">
            <h2>Bedarf</h2>
        </div>
        <div class="capacity-row" *ngFor="let er of EmployeeResources; let f = last; let i = index">
            <mat-form-field appearance="fill" style="width: 13rem;">
                <mat-label>Zeitraum</mat-label>
                <mat-date-range-input
                    [formGroup]="er.form"
                    [rangePicker]="timespanPicker">
                    <input matStartDate placeholder="Von" formControlName="from">
                    <input matEndDate placeholder="Bis" formControlName="to">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="timespanPicker"></mat-datepicker-toggle>
                <mat-date-range-picker #timespanPicker></mat-date-range-picker>
            </mat-form-field>

            <mat-form-field  appearance="fill" style="width: 10rem;">
                <mat-label>Anzahl Mitarbeiter</mat-label>
                <input matInput type="number" min="0" [formControl]="er.form.controls.amount">
            </mat-form-field>
            <mat-form-field appearance="fill" style="width: 11rem;">
                <mat-label>
                    Jobbezeichnung
                </mat-label>
                <fa-icon matSuffix icon="times" style="margin-left: 3px; cursor: pointer;" (click)="er.form.controls.jobSpecification.setValue(null);onEmployeeResourceJobSelectionChange(er.form);$event.stopPropagation();" *ngIf="!er.form.controls.jobSpecification.disabled"></fa-icon>
                <app-select-search
                    [required]="HasRequiredField(er.form.controls.jobSpecification)"
                    [formControl]="er.form.controls.jobSpecification"
                    [Options]="JobSpecifications$ | async"
                    [SearchFunction]="SearchJobSpecification"
                    [OptionTemplate]="jobSpecificationOptionTemplate"
                    (selectionChange)="onEmployeeResourceJobSelectionChange(er.form)"
                ></app-select-search>
            </mat-form-field>
            <ng-template #jobSpecificationOptionTemplate let-option>
                <app-job-specification-option [JobSpecificationEntity]="option"></app-job-specification-option>
            </ng-template>
            <app-chip-autocomplete
                appearance="fill"
                style="min-width: 20rem;"
                [formControl]="er.form.controls.activities"
                [MapFn]="activityToLabel"
                [Options]="er.availableActivities$ | async"
                Placeholder="Tätigkeiten"
                (UnknownOptionSubmitted)="addNewActivity($event, er.form.controls.activities)"
                [OptionTemplate]="activityOptionTemplate"
            ></app-chip-autocomplete>
            <ng-template #activityOptionTemplate let-Option>
                <div style="display: flex; justify-content: space-between; align-items: center">
                    {{Option.Name}} <button *ngIf="!Option.DeletedAt" mat-icon-button (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation(); DeleteActivity(Option);"><fa-icon icon="trash"></fa-icon></button>
                </div>
            </ng-template>

            <mat-form-field appearance="fill" style="width: 10rem;">
                <mat-label>Name</mat-label>
                <input matInput type="text" [formControl]="er.form.controls.name">
            </mat-form-field>
            <mat-form-field appearance="fill" style="width: 11rem;">
                <mat-label>Farbe</mat-label>
                <input matInput [ngxMatColorPicker]="picker" [formControl]="er.form.controls.color">
                <app-mat-color-picker-toggle matSuffix [for]="picker"></app-mat-color-picker-toggle>
                <app-mat-color-preview matPrefix [for]="picker"></app-mat-color-preview>
                <ngx-mat-color-picker #picker [disabled]="er.form.controls.color.disabled" [touchUi]="BS.TouchQuery | async" [color]="'primary'"></ngx-mat-color-picker>
            </mat-form-field>
            <div class="buttonSpacer">
                <button app-round-button *ngIf="f" (click)="AddResourceEmployee()"><fa-icon icon="plus"></fa-icon></button>
            </div>
            <button mat-icon-button (click)="RemoveResourceEmployee(i)"><fa-icon icon="trash"></fa-icon></button>
        </div>
    </div>
</ng-template>
<ng-template #addressTemplate>
    <app-detail-list-template [Inline]="true" [Data]="{Properties: [DetailListTemplateEntrys.Location, DetailListTemplateEntrys.TravelZoneId]}" [Editing]="true"> </app-detail-list-template>
</ng-template>
<ng-template #pageOne>
    <ng-container *ngIf="parentCommission$ | async">
        <label id="example-radio-group-label">Adresse übernehmen von:</label>
        <mat-radio-group
            aria-labelledby="example-radio-group-label"
            class="example-radio-group"
            [ngModel]="addressFrom"
            (ngModelChange)="onAddressFromChange($event)"
        >
            <mat-radio-button class="example-radio-button" *ngFor="let season of addressFromValues$ | async" [value]="season.value">
                {{season.label}}
            </mat-radio-button>
        </mat-radio-group>
    </ng-container>
</ng-template>

<ng-template #stepOneTemplateKapl let-properties="Properties">
    <app-detail-list-template [Inline]="true"  [Editing]="true"
        [Data]="{Properties: [
            DetailListTemplateEntrys.Customer,
            DetailListTemplateEntrys.Description,
            DetailListTemplateEntrys.ParentCommission,
            DetailListTemplateEntrys.ProjectInfo,
            DetailListTemplateEntrys.CommissionType,
            DetailListTemplateEntrys.Kostenstellenart,
            DetailListTemplateEntrys.DepartmentId,
        ]}">
    </app-detail-list-template>
<!--    <div class="select-and-button-container">-->
<!--        <mat-form-field>-->
<!--            <mat-label>Anfragekontakt</mat-label>-->
<!--            <app-select-search-->
<!--                [formControl]="DetailListTemplateEntrys.Person.formControl"-->
<!--                [Options]="personOptions$ | async"-->
<!--                [OptionTemplate]="personTemplate"-->
<!--                [CompareOptions]="compareById"-->
<!--                [SearchFunction]="planedBySearchFunction"-->
<!--            >-->
<!--                <div search-bar-suffix>-->
<!--                    <button-->
<!--                        mat-icon-button-->
<!--                        class="mat-badge-more-overlay"-->
<!--                        matBadgeSize="small"-->
<!--                        [matBadge]="personFilterCount$ | async"-->
<!--                        (click)="filterPerson.Open()"-->
<!--                    >-->
<!--                        <fa-icon icon="filter"></fa-icon>-->
<!--                    </button>-->
<!--                    <app-filter-card UnlimitedHeight #filterPerson [Settings]="personFilterSettings$ | async" [Values]="personFilterValues$ | async" (ValuesChange)="personFilterValues$.next($event)"></app-filter-card>-->
<!--                </div>-->
<!--            </app-select-search>-->

<!--        </mat-form-field>-->
<!--        <button-->
<!--            app-round-button-->
<!--            matTooltip="Kontakt anlegen"-->
<!--            type="button"-->
<!--            (click)="onAddPersonButtonClick(DetailListTemplateEntrys.Person.formControl)"-->
<!--        >-->
<!--            <fa-icon icon="plus"></fa-icon>-->
<!--        </button>-->
<!--    </div>-->

    <h3 class="mt-4 mb-2" style="text-decoration: underline">Baustellenadresse</h3>

    <app-detail-list-template [RequiredAdress]="true" [Inline]="true" [Data]="{Properties: [DetailListTemplateEntrys.Location]}" [Editing]="true"> </app-detail-list-template>
</ng-template>

<ng-template #stepTwoTemplateKapl let-properties="Properties">
    <mat-form-field>
        <mat-label>verantwortlicher Projektadmin</mat-label>
        <app-select-search
            [formControl]="DetailListTemplateEntrys.ProjectAdmin.formControl"
            [Options]="employeeOptions$ | async"
            [OptionTemplate]="employeeTemplate"
            [CompareOptions]="compareById"
            [SearchFunction]="planedBySearchFunction"
        >
            <div search-bar-suffix>
                <button
                    mat-icon-button
                    class="mat-badge-more-overlay"
                    matBadgeSize="small"
                    [matBadge]="singleEmployeeFilterCount$ | async"
                    (click)="filterEmployee.Open()"
                >
                    <fa-icon icon="filter"></fa-icon>
                </button>
                <app-filter-card UnlimitedHeight #filterEmployee [Settings]="singleEmployeeFilterSettings$ | async" [Values]="singleEmployeeFilterValues$ | async" (ValuesChange)="singleEmployeeFilterValues$.next($event)"></app-filter-card>
            </div>
        </app-select-search>

    </mat-form-field>
    <mat-form-field>
        <mat-label>Projektverantwortlicher</mat-label>
        <app-select-search
            [formControl]="DetailListTemplateEntrys.ProjectManager.formControl"
            [Options]="employeeOptions$ | async"
            [OptionTemplate]="employeeTemplate"
            [CompareOptions]="compareById"
            [SearchFunction]="planedBySearchFunction"
        >
            <div search-bar-suffix>
                <button
                    mat-icon-button
                    class="mat-badge-more-overlay"
                    matBadgeSize="small"
                    [matBadge]="employeeFilterCountManager$ | async"
                    (click)="filterManager.Open()"
                >
                    <fa-icon icon="filter"></fa-icon>
                </button>
                <app-filter-card UnlimitedHeight #filterManager [Settings]="singleEmployeeFilterSettings$ | async" [Values]="singleEmployeeFilterValues$ | async" (ValuesChange)="singleEmployeeFilterValues$.next($event)"></app-filter-card>
            </div>
        </app-select-search>

    </mat-form-field>
    <app-detail-list-template [Inline]="true"  [Editing]="true"
                              *ngIf="departmentsForSubCommissions$ | async as departmentProperty"
        [Data]="{Properties: [
            departmentProperty,
            DetailListTemplateEntrys.PlanedStartDate,
        ]}">
    </app-detail-list-template>
    <app-comment-list
        *ngIf="Commission$ | async as commission"
        [CanDelete]="IamAssignee$ | async"
        [ViewConfig]="commentView"
        [EntityId]="commission.Id"
        [EntityType]="CommentEntityTypeEnum.Commission"
        [FileUploadParams]="CommentFileUploadParams$ | async"
    ></app-comment-list>
    <app-detail-list-template [Inline]="true"  [Editing]="true"
                              [Data]="{Properties: [

            DetailListTemplateEntrys.StatusBackofficeId,
            DetailListTemplateEntrys.OfferSubmissionDate,
        ]}">
    </app-detail-list-template>
        <div class="select-and-button-container">
    <mat-form-field>
        <mat-label>Planung durch</mat-label>
        <app-select-search
            [formControl]="planedby"
            [Options]="employeePersonOptions$ | async"
            [OptionTemplate]="employeePersonTemplate"
            [CompareOptions]="compareById"
            [SearchFunction]="planedBySearchFunction"
        >
            <div search-bar-suffix>
                <button
                    mat-icon-button
                    class="mat-badge-more-overlay"
                    matBadgeSize="small"
                    [matBadge]="employeeFilterCount$ | async"
                    (click)="filter.Open()"
                >
                    <fa-icon icon="filter"></fa-icon>
                </button>
                <app-filter-card UnlimitedHeight #filter [Settings]="employeeFilterSettings$ | async" [Values]="employeeFilterValues$ | async" (ValuesChange)="employeeFilterValues$.next($event)"></app-filter-card>
            </div>
        </app-select-search>

    </mat-form-field>
    <button
        app-round-button
        matTooltip="Kontakt anlegen"
        type="button"
        (click)="onAddPersonButtonClick(planedby)"
    >
        <fa-icon icon="plus"></fa-icon>
    </button>
        </div>
    <div class="select-and-button-container">
    <mat-form-field>
        <mat-label>Ausschreiber</mat-label>
        <app-select-search
            [formControl]="agent"
            [Options]="employeePersonOptionsAgent$ | async"
            [OptionTemplate]="employeePersonTemplate"
            [CompareOptions]="compareById"
            [SearchFunction]="planedBySearchFunction"
        >
            <div search-bar-suffix>
                <button
                    mat-icon-button
                    class="mat-badge-more-overlay"
                    matBadgeSize="small"
                    [matBadge]="employeeFilterCountAgent$ | async"
                    (click)="filterAgent.Open()"
                >
                    <fa-icon icon="filter"></fa-icon>
                </button>
                <app-filter-card UnlimitedHeight #filterAgent [Settings]="employeeFilterSettings$ | async" [Values]="employeeFilterValuesAgent$ | async" (ValuesChange)="employeeFilterValuesAgent$.next($event)"></app-filter-card>
            </div>
        </app-select-search>

    </mat-form-field>
    <button
        app-round-button
        matTooltip="Kontakt anlegen"
        type="button"
        (click)="onAddPersonButtonClick(agent)"
    >
        <fa-icon icon="plus"></fa-icon>
    </button>
    </div>

</ng-template>
<ng-template #employeePersonTemplate let-option>
    <span *ngIf="option.EntityType ==='Employee'"><fa-icon icon="user"></fa-icon>{{" "+option.optionLabel}}</span>
    <span *ngIf="option.EntityType ==='Person'"><fa-icon icon="address-book"></fa-icon> {{" "+option.optionLabel}}</span>
</ng-template>
<ng-template #personTemplate let-option>
    <span><fa-icon icon="address-book"></fa-icon> {{" "+option.optionLabel}}</span>
</ng-template>

<ng-template #employeeTemplate let-option>
    <span><fa-icon icon="user"></fa-icon> {{" "+option.optionLabel}}</span>
</ng-template>
<ng-template #parentCommissionSearchTemplate>
    <mat-form-field>
        <mat-label>{{CommissionEntity.EntityPropertyNames.get('ParentId')}}</mat-label>
        <app-select-search
            [formControl]="DetailListTemplateEntrys.ParentCommission.formControl"
            [Options]="parentCommissionOptionsSorted$ | async"
            [OptionTemplate]="parentCommissionOptionTemplate"
            [CompareOptions]="compareById"
            [SearchFunction]="parentCommissionOptionSearchFunction"
        ></app-select-search>
    </mat-form-field>
    <div style="height: 1.5em">
        <span *ngIf="parentCommissionOptionsFilterResultCount$ | async as count">
            <ng-container *ngIf="count === 1">Es wurde ein {{cls.getSingle$('Commission') | async}} mit ähnlichen daten gefunden</ng-container>
            <ng-container *ngIf="count > 1">Es wurden {{count}} {{cls.getMultiple$('Commission') | async}} mit ähnlichen daten gefunden</ng-container>
        </span>
    </div>
    </ng-template>
<ng-template #parentCommissionOptionTemplate let-option>
    <span [class.font-bold]="option.isSearchResult">{{option.optionLabel}}</span>
</ng-template>


